var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100vh","overflow":"hidden"}},[(_vm.showMask && _vm.fileType=='wps')?_c('div',{staticClass:"mask"}):_vm._e(),(_vm.frameUrl)?_c('iframe',{attrs:{"src":_vm.frameUrl,"id":"player","width":"100%","height":"100%","frameborder":"0"},on:{"load":_vm.onFrameLoaded}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }